import React from "react"
import styled from "@emotion/styled"
import { css } from "@emotion/react"
import ScrollAnimation from "components/ScrollAnimation"

interface IBarChartProps {
	value: number
	colorHEX?: string
	whiteText?: boolean
	animate?: boolean
}

interface IChartValProps {
	color: string
	animate?: boolean
}

interface IBarChartContainerProps {
	value: number
}

const whiteTextStyles = css`
	color: #fff;
`

const ChartVal = styled.rect<IChartValProps>`
	height: 100%;
	width: 0%;
	${({ animate }) =>
		animate &&
		css`
			transition: width 2s cubic-bezier(0.45, 0.82, 0.095, 1);
		`}
	${({ color }) =>
		color &&
		css`
			fill: ${color};
		`}
`

const BarChartContainer = styled.div<IBarChartContainerProps>`
	display: flex;
	flex-direction: column;
	margin-bottom: 5px;

	&.animate {
		${ChartVal} {
			${({ value }) =>
		value &&
				css`
					width: ${value}%;
				`}
		}
	}
`

const BarChartLabel = styled.h5`
	font-size: 1.2rem;
	line-height: 2.4rem;
	font-weight: 600;
	margin-bottom: 0;
	color: #fff;
`

const BarChartWrapper = styled.div`
	display: flex;
`

const ChartWrapper = styled.svg``

const ChartBg = styled.rect`
	height: 100%;
	width: 100%;
	fill: #fbfbfb;
	opacity: 10%;
`

const BarChartPercentage = styled.div`
	font-size: 1.2rem;
	line-height: 2.4rem;
	font-weight: 800;
	margin-left: 5px;
	min-width: 40px;
	text-align: right;
	color: #fff;
`

const BarChart: React.FC<IBarChartProps> = ({ value = 0, colorHEX = "#01C1B7", whiteText, animate, children }) => {
	return (
		<ScrollAnimation addClass>
			<BarChartContainer value={value}>
				<BarChartLabel css={whiteText && whiteTextStyles}>{children}</BarChartLabel>
				<BarChartWrapper>
					<ChartWrapper width="100%" height="22px">
						<g>
							<ChartVal animate={animate} color={colorHEX} />
							<ChartBg />
						</g>
					</ChartWrapper>
					<BarChartPercentage css={whiteText && whiteTextStyles}>{value > 0 && `${value}%`}</BarChartPercentage>
				</BarChartWrapper>
			</BarChartContainer>
		</ScrollAnimation>
	)
}

export default BarChart
